export function addZeroWidthSpaceBeforeAtSign(email) {
    const atSignIndex = email.indexOf('@');
    if (atSignIndex === -1) {
        return email;
    }
    return `${email.slice(0, atSignIndex)}\u200B${email.slice(atSignIndex)}`;
}
